import { render, staticRenderFns } from "./PickUpWarehouseModal.vue?vue&type=template&id=45f72f59&scoped=true"
import script from "./PickUpWarehouseModal.vue?vue&type=script&lang=js"
export * from "./PickUpWarehouseModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f72f59",
  null
  
)

export default component.exports